/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OccurrenceImpactLevelDto } from '../../models/occurrence-impact-level-dto';

export interface GetAllOccurrenceImpactLevels$Params {
}

export function getAllOccurrenceImpactLevels(http: HttpClient, rootUrl: string, params?: GetAllOccurrenceImpactLevels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OccurrenceImpactLevelDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllOccurrenceImpactLevels.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OccurrenceImpactLevelDto>>;
    })
  );
}

getAllOccurrenceImpactLevels.PATH = '/occurrence-impact-levels';
